export default 'https://tme.understood.org/assets/confusion.0d55db7c.lottie'